/**
 * Utility functions for determining widget visibility and control visibility
 */

/**
 * Check if add/delete controls should be shown for a widget
 * This function matches the exact visibility logic used by widgets themselves
 */
export const shouldShowAddDeleteControls = (
  widget: any,
  isEditMode: boolean,
): boolean => {
  const widgetType = widget.type?.toLowerCase();
  const safeData = {
    selectedItemIds: widget.data?.selectedItemIds || [],
    menuData: widget.data?.menuData || [],
  };

  // Popular Items - check for valid available menu items first
  if (widgetType?.includes("popular")) {
    if (!safeData.menuData || !Array.isArray(safeData.menuData)) {
      return false;
    }

    const validMenuItems = safeData.menuData.filter((item: any) => {
      if (!item) return false;
      const isEnabled = item.is_enabled === true || item.is_enabled === "true";
      const hasInventory =
        item.inventory_status === true || item.inventory_status === "true";
      const isVerified =
        item.is_item_verified === true || item.is_item_verified === "true";
      return isEnabled && hasInventory && isVerified;
    });
    if (validMenuItems.length === 0) {
      return false;
    }
    if (!isEditMode) {
      if (!safeData.selectedItemIds || safeData.selectedItemIds.length === 0) {
        return false;
      }
    }
    return true;
  }
  // Limited Time Items - only check menuData
  if (widgetType?.includes("limitedtime")) {
    if (!Array.isArray(safeData.menuData)) {
      return false;
    }
    if (safeData.menuData.length === 0) {
      return false;
    }
    return true;
  }
  // All other widgets always show controls
  return true;
};
